module.exports = __webpack_public_path__ + "img/knzb-shop.e23f80a4.jpg";